import React, { useState } from "react";
import './main-header.css';
import Auth from "../auth/auth";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown } from "antd";
import { serverFetch } from "@src/server";
import { userLoaded } from "@src/store/actions";
import { UserOutlined } from "@ant-design/icons";
import { useWindowWidth } from "@react-hook/window-size";
import Account from "../auth/account";
import { useNavigate } from "react-router-dom";
import ChangePassword from "../auth/change-password";

const MainHeader = () => {
    const d = useDispatch();
    const user = useSelector((s) => s.user);
    const [showSignin, setShowSignin] = useState(window.location.pathname == "/sales" && !user);
    const onlyWidth = useWindowWidth();
    const [showAccountInfo, setShowAccountInfo] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const navigate = useNavigate();
    const isCompact = onlyWidth <= 720;

    const logout = () => serverFetch('auth/logout', {method: 'POST'})
        .then(() => d(userLoaded(undefined)))
        .catch(() => d(userLoaded(undefined)));

    const items = [
        {
            key: '1',
            label: (<Button type='link' className='account-item-btn' onClick={() => setShowAccountInfo(true)} size='middle'>Мои данные</Button>),
        },
        { 
            key: '3',
            label: (<Button type='link' className='account-item-btn' onClick={() => navigate(`/sales`)} size='middle'>Путевки</Button>),
        },
        { 
            key: '4',
            label: (<Button type='link' className='account-item-btn' onClick={() => setShowChangePassword(true)} size='middle'>Сменить пароль</Button>),
        },
        {
            key: '2',
            label: (<Button type='link' className='account-item-btn' onClick={() => logout()} size='middle'>Выход</Button>),
        },
    ];

    const accountBtnClass = `main-account-btn${isCompact ? ' main-account-btn-compact' : ''}`;

    const divLogin = user ? (
        <Dropdown menu={{ items: items }} placement='bottomRight'>
            <Button type='link' className={accountBtnClass} size='middle'>
                <UserOutlined/>{!isCompact && (`${user.email}`)}
            </Button>
        </Dropdown>
    ) : (
        <Button type='link' className={accountBtnClass} onClick={() => setShowSignin(true)} size='middle' icon={<UserOutlined />}>
            {!isCompact && 'Личный кабинет'}
        </Button>
    )

    return <div className="main-header">
        <div className="main-header-content">
            <a href="/"><img src="/images/logo.svg" className="logo-svg" alt="КУПИТЬ ПУТЁВКУ" /></a>
            {divLogin}
        </div>
        {showSignin && <Auth onClose={() => setShowSignin(false)} />}
        {showAccountInfo && <Account onClose={() => setShowAccountInfo(false)} />}
        {showChangePassword && <ChangePassword onClose={() => setShowChangePassword(false)} />}
    </div>
}

export default MainHeader;
